import { render, staticRenderFns } from "./RegisterNow.vue?vue&type=template&id=0ef6170c&scoped=true&"
import script from "./RegisterNow.vue?vue&type=script&lang=js&"
export * from "./RegisterNow.vue?vue&type=script&lang=js&"
import style0 from "./RegisterNow.vue?vue&type=style&index=0&id=0ef6170c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef6170c",
  null
  
)

export default component.exports